import React from 'react'
import { getFormValues } from 'redux-form'
import { toast } from 'react-toastify'
import { FORM_PROCESO_CALADO, FORM_ANULACION_EGRESO, FORM_EGRESO_CALADO } from '../../../config/forms'
import { requestDatosConsultaCpa, showDialogoPenalizacion, getCamionesEntrePlayaCalado, getCortesPedidos, obtenerDatosCpaEnPlaya } from '../../Camiones/actions'
import ConsultaCea from '../../../models/calado/consulta_cea'
import CondicionIngreso from '../../../models/calado/condicion_ingreso'
import CalleCalado from '../../../models/calado/calle_calado'
import CamionesCalados from '../../../models/calado/camiones_calados'
import CargaEntranteAutomotorCalado from '../../../models/calado/carga_entrante_automotor_calado'
import PreIngresoCalado from '../../../models/calado/pre_ingreso'
import LecturaDeAnalisis from '../../../models/sonda/lectura_de_analisis'
import RegistroAnalisisCalador from '../../../models/sonda/registro_analisis_calador'
import { requestCerealEspecie } from '../../Cereal/actions'
import ParametroText from '../../../models/parametro/parametro_text'
import Printer from '../../../models/impresora'
import VerificarPatenteDialog from '../components/VerificarPatenteDialog'
import DialogPdfAfip from '../components/DialogPdfAfip'
import ListadoCamionesCalados from '../components/ListadoCamionesCalados'
import { openDialogHuella, closeDialogHuella, obtenerHuellaDigital } from '../../Huella/actions'
import { setShowFooter } from '../../Utils/actions'
import { actualizarDatosParaMuiTable } from '../../Camiones/containers/listados/camionesCalados/actions/TablaCamionesCaladosActions'
import { TablaCamionesCaladosService } from '../../Camiones/containers/listados/camionesCalados/servicio/tabla_camiones_calados'
import CamionesPenalizados from '../../../models/camiones/camiones_penalizados'
import moment from 'moment'
import BarreraCalado from '../../../models/barreras/calado'
import DialogoCalleCamionCaladoUpdate from '../components/egresoCalado/DialogoCalleCamionCaladoUpdate'
import { TABLA_CALLES_DE_CALADO, TABLA_CAMIONES_CALADO_EN_CALLES } from '../../../config/tables'
import { COLUMNS_CAMIONES_CALADO_EN_PLAYA } from './constantsCamionesCaladosEnPlaya'
import { INTERVALO_CORTO } from '../../../config/settings'
import { camionesListosParaBruto, obtenerPedidosDeBruto } from '../../Pesado/actions'
import { COLUMNS_CALLE_CALADO } from './constants'

export function hideSaveCaladoModal () {
  return (dispatch) => {
    dispatch({ type: 'HIDE_SAVE_CALADO_MODAL' })
  }
}

export function selectPuestoCalado (puestoCalado, nombrePuestoCalado, calleA, calleB) {
  return (dispatch) => {
    dispatch({
      type: 'SELECT_PUESTO_CALADO',
      puestoCalado,
      nombrePuestoCalado,
      calleA,
      calleB
    })
  }
}

export function selectPrinter (printer, printerName) {
  return (dispatch) => {
    dispatch({
      type: 'SELECT_PRINTER_CALADO',
      printer,
      printerName
    })
  }
}

export function resetPrinter () {
  return (dispatch) => dispatch({ type: 'RESET_PRINTER_CALADO' })
}

export function showNoAdmitible () {
  return dispatch => {
    dispatch({ type: 'SHOW_CARGA_NO_ADMITIBLE' })
  }
}

export function hideNoAdmitible () {
  return dispatch => {
    dispatch({ type: 'HIDE_CARGA_NO_ADMITIBLE' })
  }
}

export function resetPuestoCalado () {
  return (dispatch) => dispatch({ type: 'RESET_PUESTO_CALADO' })
}

export function obtenerAnalisisSonda (numero) {
  return (dispatch, getState) => {
    return LecturaDeAnalisis.getAnalisis(numero)
      .then((data) => {
        dispatch({
          type: 'ANALISIS_SONDA',
          lecturaAnalisisSonda: data
        })
        console.log('Analisis', data)
      })
  }
}

export function requestCea (numero, callback) {
  return dispatch => {
    dispatch({ type: 'REQUEST_CONSULTA_CEA' })
    ConsultaCea.getById(numero)
      .then(consultaCea => {
        dispatch({ type: 'RECEIVE_CONSULTA_CEA', consultaCea })
        callback && callback(consultaCea)
      })
      .catch(_ => dispatch({
        type: 'RECEIVE_CONSULTA_CEA',
        consultaCea: null
      }))
  }
}

export function updateConsultaCea (newValue) {
  return dispatch => {
    dispatch({ type: 'UPDATE_CONSULTA_CEA', newValue })
  }
}

export function dialogoPenalizacion (newValue) {
  return dispatch => {
    dispatch(showDialogoPenalizacion(newValue))
  }
}

export function getDatosPreIngresoCalado (numero, calle) {
  return dispatch => {
    dispatch(requestDatosConsultaCpa(numero, (cpa) => {
      if (!cpa) {
        dispatch(cancelPreIngresoCalado())
      } else {
        CamionesPenalizados.getPenalizadosVigentes(cpa.camion, cpa.claveCereal)
          .then((result) => {
            if (result && (result.patente.trim() === cpa.camion.trim() || result.patente.trim() === cpa.acoplado.trim())) {
              const patente = result.patente
              const motivo = result.motivo
              const vencimiento = result.fechaVencimiento
              dispatch({ type: 'TRANSPORTE_TERRESTRE_PENALIZADO', patente, motivo, vencimiento })
              dispatch(dialogoPenalizacion(true))
            } else {
              CamionesPenalizados.getPenalizadosVigentes(cpa.acoplado, cpa.claveCereal)
                .then((resultado) => {
                  if (resultado && (resultado.patente.trim() === cpa.acoplado.trim() || resultado.patente.trim() === cpa.acoplado.trim())) {
                    const patente = resultado.patente
                    const motivo = resultado.motivo
                    const vencimiento = resultado.fechaVencimiento
                    dispatch({ type: 'TRANSPORTE_TERRESTRE_PENALIZADO', patente, motivo, vencimiento })
                    dispatch(showDialogoPenalizacion(true))
                  } else {
                    dispatch(obtenerFotoCalado(numero, calle))
                    if (cpa['estadoIngreso'] === 'ingreso_completo' &&
                    cpa['estadoCtg'] && !cpa['fechaDeAbandono'] && !cpa['fechaDeDestare'] &&
                    (cpa['estadoCtg'] !== 'R')) {
                    // (cpa.rechazoAdministrativoCalado !== 'R') && (cpa.estadoCalificacion !== 'R')) {
                      PreIngresoCalado.eliminarCallePreIngresoPorNumero(numero)
                      dispatch(preIngresoNextStep())
                    } else {
                      dispatch(cancelPreIngresoCalado())
                      if (cpa.estadoCalificacion === 'R') {
                      }
                      if (cpa.rechazoAdministrativoCalado === 'R') {
                      }
                    }
                  }
                })
            }
          })
      }
    }))
  }
}

export function obtenerFotoCalado (numero, calle) {
  return dispatch => {
    PreIngresoCalado.obtenerFoto(numero, calle)
    dispatch({ type: 'OBTENER_FOTO_PREINGRESO_CALADO' })
  }
}

export function getFoto (numero) {
  return dispatch => {
    ConsultaCea.getFotoCea(numero)
      .then(data => {
        dispatch({ type: 'RECEIVE_FOTO_CEA', data })
      })
  }
}

export function resetFoto () {
  return dispatch => {
    dispatch({ type: 'RESET_FOTO_CEA' })
  }
}

export function deleteFoto (fechaPreingreso) {
  return dispatch => {
    ConsultaCea.deleteFotoCea(fechaPreingreso)
  }
}

export function admitibleEnCalado (numero) {
  return (dispatch) => {
    dispatch(requestDatosConsultaCpa(numero, (cpa) => {
      if (cpa && cpa['estadoIngreso'] === 'ingreso_completo' &&
          cpa['estadoCtg'] && !cpa['fechaDeAbandono'] && !cpa['fechaDeDestare']) {
        dispatch(requestCea(cpa.numero, (cea) => {
          if (cea && cea['pesoBruto'] && !cea['rechazoEnPesado']) {
            dispatch(showNoAdmitible())
          } else {
            dispatch(requestCerealEspecie(
              (cea && cea['claveCereal']) || cpa['claveCereal'], () => {
                dispatch(caladoNextStep())
              }))
          }
        }))
      }
    }
    ))
  }
}

export function obtenerCPEcalle (calle) {
  return (dispatch) => {
    PreIngresoCalado.consultaPorCalle(calle)
      .then(data => {
        dispatch({ type: 'RECEIVE_CPE', data })
        if (data && !data.error) {
          console.log('cpe', data)
          console.log('Nro', data['nroCtge'])
          if (data['admisible']) {
            dispatch(requestDatosConsultaCpa(data['nroCtge'], (cpa) => {
              if (cpa && cpa['estadoIngreso'] === 'ingreso_completo' &&
                    cpa['estadoCtg'] && !cpa['fechaDeAbandono'] && !cpa['fechaDeDestare']) {
                dispatch(requestCea(cpa.numero, (cea) => {
                  if (cea && cea['pesoBruto'] && !cea['rechazoEnPesado']) {
                    toast.error(`La CPE ${cea['cartaDePorteAutomotor']} ya se encuentra pesada. Verifiquela.`)
                    dispatch(showNoAdmitible())
                  } else if (cpa['estadoCtg'] === 'R') {
                    toast.error(`La CPE ${cea['cartaDePorteAutomotor']} fue rechazada.`)
                  } else {
                    dispatch(requestCerealEspecie((cea && cea['claveCereal']) || cpa['claveCereal']))
                    dispatch(openDialogPatente(calle))
                  }
                }))
              } else {
                toast.error(`La CPE ${data['nroCtge']} tiene incorrecto el estado de ctge o el abandono. Verifiquela.`)
                dispatch(showNoAdmitible())
              }
            }))
          } else {
            toast.error(`La CPE ${data['nroCtge']} esta marcada como no admisible. Verifiquela.`)
          }
        } else {
          toast.error('Error al obtener las cartas de porte.')
        }
      })
  }
}

export function updateEstadoCallePreingreso (calle, numero = null, cereal = null) {
  return (dispatch) => {
    const data = (numero && cereal) ? { numero: numero, cereal: cereal } : null
    return dispatch({ type: `ESTADO_CALLE_${calle}_PREINGRESO_CALADO`, data })
  }
}

export function getEstadoCalle (calle) {
  return (dispatch) => {
    PreIngresoCalado.consultaPorCalle(calle)
      .then(data => {
        dispatch({ type: `RECEIVE_ESTADO_CALLE_${calle}`, data })
        if (data && !data.error) {
          return dispatch(updateEstadoCallePreingreso(calle, data['nroCtge'], data['cereal']))
        } else if (!data) {
          return dispatch(updateEstadoCallePreingreso(calle))
        }
      })
  }
}

export function caladoNextStep () {
  return (dispatch) => {
    return dispatch({ type: 'PROCESO_CALADO_NEXT_STEP' })
  }
}

export function caladoPrevStep () {
  return (dispatch) => {
    return dispatch({ type: 'PROCESO_CALADO_PREV_STEP' })
  }
}

export function preIngresoNextStep () {
  return (dispatch) => {
    return dispatch({ type: 'PRE_INGRESO_CALADO_NEXT_STEP' })
  }
}

export function finalizarPreIngreso () {
  return (dispatch) => {
    return dispatch({ type: 'END_PRE_INGRESO_CALADO' })
  }
}

export function egresoQRNextStep () {
  return (dispatch) => {
    return dispatch({ type: 'EGRESO_QR_CALADO_NEXT_STEP' })
  }
}

export function finalizarEgresoQR () {
  return (dispatch) => {
    return dispatch({ type: 'END_EGRESO_QR_CALADO' })
  }
}

export function submitPreIngresoCalado (numero, calle) {
  return dispatch => {
    return PreIngresoCalado.cargaPreIngresoCalado(numero, calle)
  }
}

export function cancelPreIngresoCalado () {
  return dispatch => {
    dispatch(finalizarPreIngreso())
  }
}

export function vaciarCallePreIngresoCalado (calle) {
  return (dispatch) => {
    dispatch(updateEstadoCallePreingreso(calle))
    return PreIngresoCalado.vaciarCallePreIngresoCalado(calle)
  }
}

export function encender12 () {
  return (dispatch) => {
    return PreIngresoCalado.encender12()
  }
}

export function encender34 () {
  return (dispatch) => {
    return PreIngresoCalado.encender34()
  }
}

export function apagar12 () {
  return (dispatch) => {
    return PreIngresoCalado.apagar12()
  }
}

export function apagar34 () {
  return (dispatch) => {
    return PreIngresoCalado.apagar12()
  }
}

export function detenerConsultaFoto () {
  return (dispatch) => {
    return dispatch({ type: 'DETENER_CONSULTA_FOTO' })
  }
}

export function openListadoCamionesCalados () {
  return (dispatch) => {
    const cancelCallback = () => {
      dispatch({
        type: 'CLOSE_DIALOG'
      })
    }
    dispatch({
      type: 'OPEN_DIALOG',
      maxWidth: 'lg',
      content: <ListadoCamionesCalados />,
      cancelCallback
    })
  }
}

export function updateEstadoBarchar (newValue) {
  return (dispatch) => {
    dispatch({ type: 'UPDATE_STATE_BARCHAR', newValue })
  }
}

export function openDialogPatente (calle) {
  return (dispatch) => {
    const confirmCallback = () => {
      caladoNextStep()(dispatch)

      dispatch({
        type: 'CLOSE_DIALOG'
      })
    }
    const cancelCallback = () => {
      dispatch({
        type: 'CLOSE_DIALOG'
      })
    }
    dispatch({
      type: 'OPEN_DIALOG',
      maxWidth: 'lg',
      content: <VerificarPatenteDialog />,
      cancelCallback,
      confirmCallback
    })
  }
}

export function updateCallePreIngreso (calle) {
  return (dispatch) => {
    return dispatch({ type: 'UPDATE_CALLE_PRE_INGRESO', calle })
  }
}

export function updateSiloAparte (newValue) {
  return (dispatch) => {
    return dispatch({ type: 'UPDATE_SILO_APARTE', newValue })
  }
}

export function updateFumigado (newValue) {
  return (dispatch) => {
    return dispatch({ type: 'UPDATE_FUMIGADO', newValue })
  }
}

export function updateZarandeo (newValue) {
  return (dispatch) => {
    return dispatch({ type: 'UPDATE_ZARANDEO', newValue })
  }
}

export function updateMotivoDeZarandeo (motivo) {
  return (dispatch) => {
    return dispatch({ type: 'UPDATE_MOTIVO_ZARANDEO', motivo })
  }
}

export function updatePendienteAutorizar (newValue) {
  return (dispatch) => {
    return dispatch({ type: 'UPDATE_PENDIENTE_AUTORIZAR', newValue })
  }
}

export function rechazoEnAfip (numero, ctg, motivo) {
  return (dispatch, getState) => {
    // const state = getState()
    return CargaEntranteAutomotorCalado.rechazarEnAfip(numero, ctg, motivo)
      .then((data) => dispatch({
        type: 'RECHAZAR_ARCA',
        data
      }),
      // toast.info(`Rechazado en ARCA con el número: ${state.calado.caladoSaveResponse}`, { autoClose: false }))
      toast.info(`La CTG ${numero} fue rechazada en ARCA.`))
  }
}

export function finalizarProcesoCalado () {
  return dispatch => {
    dispatch({ type: 'END_PROCESO_CALADO' })
  }
}

export function imprimirEtiquetaIngreso (numero, impresora, reimpresion = null) {
  return dispatch => {
    dispatch({ type: 'IMPRESION_DE_OBLEA' })
    return Printer.imprimirEtiquetaIngreso({
      numero, impresora, reimpresion
    })
  }
}

export function updateImpOblea (newValue) {
  return dispatch => {
    dispatch({ type: 'UPDATE_IMPRESION_OBLEA', impoblea: newValue })
  }
}

export function saveAnalisisSonda (numero, analisisSonda) {
  return dispatch => {
    dispatch({ type: 'GUARDAR_ANALISIS_SONDA' })
    RegistroAnalisisCalador.altaAnalisis(numero, analisisSonda)
      .then(result => dispatch({
        type: 'ANALISIS_SONDA_GUARDADO' })
      )
      .catch(err => err)
  }
}

// export function escribirDisplay (state, { calle, display }) {
//   return dispatch => {
//     const displayReal = display > 2 ? display - 2 : display
//     const url = display > 2 ? state.calado.url34 : state.calado.url12
//     return displayWriter(url, displayReal, calle)
//       .then(result => dispatch({
//         type: 'DISPLAY_WRITE_STATUS',
//         result
//       }))
//   }
// }

export function submitProcesoCalado (perito, calleDeIngreso, callback) {
  return (dispatch, getState) => {
    const state = getState()
    const caladoValues = getFormValues(FORM_PROCESO_CALADO)(state)
    caladoValues.peritoCalador = perito
    caladoValues.puestoCalado = state.calado.puestoCalado
    caladoValues.numero = state.camionesIngreso.consultaCpa.numero
    const { numero, caladoCheckboxes } = caladoValues
    caladoValues.fumigado = state.calado.fumigado
    caladoValues.siloAparte = state.calado.siloAparte
    caladoValues.caravana = !(state.calado.siloAparte)
    caladoValues.humedad = state.calado.humedad
    caladoValues.pendienteAutorizar = state.calado.pendienteAutorizar
    caladoValues.cereal = state.camionesIngreso.consultaCpa.claveCereal
    caladoValues.calleDeIngreso = calleDeIngreso
    caladoValues.zarandeo = state.calado.zarandeo
    caladoValues.motivoDeZarandeo = state.calado.motivoDeZarandeo

    if (caladoValues.modoIngreso === 'R' && caladoValues.condicionIngreso === 'RINFEC  ') {
      const camion = state.camionesIngreso.consultaCpa.camion
      const acoplado = state.camionesIngreso.consultaCpa.acoplado
      const fechaActual = moment().format('YYYY-MM-DD')
      CamionesPenalizados.deletePenalizacionCamion(camion, fechaActual)
      CamionesPenalizados.deletePenalizacionAcoplado(acoplado, fechaActual)
    }

    const analisisSonda = state.calado.lecturaAnalisisSonda
    const anularPromise = caladoCheckboxes.includes('anularAnalisis')
      ? CargaEntranteAutomotorCalado.anularAnalisis(numero)
      : Promise.resolve(true)

    return anularPromise.then(() => {
      return CargaEntranteAutomotorCalado.altaAnalisisCalado(caladoValues)
    }).then(async (saveStatus) => {
      dispatch({ type: 'SUBMIT_CALADO_RESPONSE', saveStatus })
      if (!saveStatus.error) {
        const condicion = caladoValues.condicionIngreso
        const motivo = state.calado.calificaciones.find((calificacion) => calificacion.calificacionCereal === condicion)
        if (caladoValues.modoIngreso === 'R') {
          console.log('Motivo', motivo, condicion)
          dispatch(rechazoEnAfip(state.camionesIngreso.consultaCpa.numero, state.camionesIngreso.consultaCpa.ctg, motivo.calificacionCereal))
        }
        // if (IsJsonString(analisisSonda)) dispatch(saveAnalisisSonda(numero, analisisSonda))
        if (analisisSonda !== undefined && analisisSonda !== null) dispatch(saveAnalisisSonda(numero, analisisSonda))
        dispatch(finalizarProcesoCalado())
        PreIngresoCalado.eliminarCallePreIngresoPorNumero(numero)
        toast.success('Operación realizada exitosamente.')
        dispatch(updateEstadoCallePreingreso(calleDeIngreso))
        callback && callback()
      }
    })
  }
}

export function updateProcesoCalado (perito, callback) {
  return (dispatch, getState) => {
    const state = getState()
    const caladoValues = getFormValues(FORM_PROCESO_CALADO)(state)
    caladoValues.peritoCalador = perito
    caladoValues.numero = state.camionesIngreso.consultaCpa.numero
    caladoValues.fumigado = state.calado.fumigado
    caladoValues.siloAparte = state.calado.siloAparte
    caladoValues.caravana = !(state.calado.siloAparte)
    caladoValues.humedad = state.calado.humedad
    caladoValues.pendienteAutorizar = state.calado.pendienteAutorizar
    caladoValues.fechaDeCalado = state.calado.consultaCea.fechaDeCalado
    caladoValues.cereal = state.calado.consultaCea.claveCereal
    return CargaEntranteAutomotorCalado.updateAnalisisCalado(caladoValues)
      .then(async (saveStatus) => {
        dispatch({ type: 'UPDATE_CALADO_RESPONSE', saveStatus })
        if (!saveStatus.error) {
          const condicion = caladoValues.condicionIngreso
          const motivo = state.calado.calificaciones.find((calificacion) => calificacion.calificacionCereal === condicion)
          if (caladoValues.modoIngreso === 'R') {
            dispatch(rechazoEnAfip(state.camionesIngreso.consultaCpa.numero, state.camionesIngreso.consultaCpa.ctg, motivo.calificacionCereal))
          }
          dispatch(actualizarDatosParaMuiTable())
          callback && callback()
        }
      })
  }
}

export function setModoIngreso (cereal, modo) {
  return dispatch => {
    dispatch({ type: 'SET_MODO_INGRESO', modo })
    dispatch({ type: 'REQUEST_CALIFICACIONES_INGRESO' })
    if (modo === 'C') {
      CondicionIngreso.getCalificacionesCondicional(cereal)
        .then(calificaciones => {
          dispatch({
            type: 'SET_CALIFICACIONES_INGRESO',
            calificaciones })
        })
        .catch(err => err)
    } else if (modo === 'R') {
      CondicionIngreso.getCalificacionesRechazo(cereal)
        .then(calificaciones => {
          dispatch({
            type: 'SET_CALIFICACIONES_INGRESO',
            calificaciones })
        })
        .catch(err => err)
    }
  }
}

export function requestCalleSugerida (claveCereal, callback) {
  return dispatch => {
    dispatch({ type: 'REQUEST_CALLE_SUGERIDA' })
    CalleCalado.CalleSugerida(claveCereal)
      .then((calle) => {
        dispatch({ type: 'RECEIVE_CALLE_SUGERIDA' })
        callback && callback(calle)
      })
  }
}

export function updateCalleSugerida (calle) {
  return dispatch => {
    dispatch({ type: 'ACTUALIZAR_CALLE_SUGERIDA', calleDeCalado: calle })
  }
}

export function requestDisplaySugerido () {
  return (dispatch) => {
    dispatch({ type: 'NEXT_DISPLAY_SUGERIDO' })
  }
}

export function actualizarDisplaySugerido (calle) {
  return dispatch => {
    dispatch({ type: 'ACTUALIZAR_DISPLAY_SUGERIDO', display: calle })
  }
}

export function setShowFooterCalado (show) {
  return (dispatch) => {
    dispatch(setShowFooter(show))
  }
}

export function queryDisplayUrls () {
  return dispatch => {
    dispatch({ type: 'REQUEST_DISPLAY_URLS' })
    Promise.all([
      ParametroText.getByNombre('URLDPLTC'),
      ParametroText.getByNombre('URLDPLUD')
    ])
      .then(([url34, url12]) => {
        dispatch({ type: 'RECEIVE_DISPLAY_URLS', url12, url34 })
      })
  }
}

export function queryAutenticacionPerito () {
  return dispatch => {
    dispatch({ type: 'REQUEST_AUTH_PERITO' })
    ParametroText.getByNombre('AUTHPERI')
      .then((estado) => {
        dispatch({ type: 'RECEIVE_AUTH_PERITO', estado })
      })
  }
}

export function getPendienteAutoriz () {
  return dispatch => {
    dispatch({ type: 'REQUEST_PENDIENTES_AUTORIZ' })
    CargaEntranteAutomotorCalado.getPendienteAutoriz()
      .then(ceaPendienteAutoriz => {
        dispatch({ type: 'RECEIVE_PENDIENTE_AUTORIZ', ceaPendienteAutoriz })
      })
  }
}

export function obtenerDatosCamionesCalados () {
  return dispatch => {
    return CamionesCalados.getCamionesCalados()
      .then((data) => dispatch({
        type: 'CAMIONES_CALADOS',
        data
      }))
  }
}

export function getCamionesCalados () {
  return (dispatch) => {
    return TablaCamionesCaladosService.getDataCamionesCalados()
      .then((data) => {
        dispatch({
          type: 'RECEIVE_CAMIONES_CALADOS',
          data
        })
      }
      )
  }
}

export function getCamionesCallesDeCaladoEgreso () {
  return dispatch => {
    dispatch({ type: 'REQUEST_CALLES_CALADO_EGRESO' })
    CalleCalado.getCamionesCallesDeCaladoEgreso()
      .then(ceaCallesCaladoEgreso => {
        dispatch({ type: 'RECEIVE_CALLES_CALADO_EGRESO', ceaCallesCaladoEgreso })
      })
  }
}

export function cargarCalleDeCaladoEgreso (selections) {
  return dispatch => {
    dispatch({ type: 'CARGAR_CALLE_DE_CALADO_EGRESO', egresos: selections })
  }
}

export function egreso () {
  return (dispatch, getState) => {
    const state = getState()
    const {
      egresosSeleccionados,
      ceaCallesCaladoEgreso
    } = state.calado

    const formValues = getFormValues(FORM_EGRESO_CALADO)(state)
    dispatch({ type: 'START_EGRESO_CALLES_CALADO' })
    const promises = []
    const camionesSiloAparte = []
    egresosSeleccionados.forEach((value) => {
      if (ceaCallesCaladoEgreso[value].caravana === false) {
        camionesSiloAparte.push(ceaCallesCaladoEgreso[value])
      }
      const calleDeBruto = formValues.calleDeBruto
      promises.push(CalleCalado.egresoCpaCalado(ceaCallesCaladoEgreso[value].cartaDePorteAutomotor, calleDeBruto))
    })
    Promise.all(promises).then(function (results) {
      results.forEach(function (obj) {
        console.log('Fin de egreso de calado', obj)
      })
      toast.success('Operación realizada exitosamente.', { autoClose: { INTERVALO_CORTO } })
      if (camionesSiloAparte.length > 0) {
        const mensaje = (
          `Atención: CAMIONES SILO APARTE
            ${camionesSiloAparte.map((c) => {
            return `${c.cartaDePorteAutomotor}`
          })}
          `
        )
        toast.info(mensaje, { autoClose: false })
      }
      dispatch(getCamionesCallesDeCaladoEgreso())
      dispatch({ type: 'END_EGRESO_CALLES_CALADO' })
    })
  }
}

export function actualizarDatosEgresoQR () {
  return (dispatch) => {
    dispatch(consultaEstadoOcupacionCallesCalado())
    dispatch(consultaCalificacionPorCalleCalado())
    dispatch(getDataCamionesCalados())
    dispatch(getCamionesCallesDeCaladoEgreso())
    dispatch(obtenerCamionesEntrePlayaCalado())
    dispatch(getDataCamionesEnPlaya())
    dispatch(getCamionesListosParaBruto())
    dispatch(obtenerPedidosDeBruto())
    dispatch(obtenerProximoEgresoCalado())
  }
}

export function egresoQR (numero) {
  return (dispatch, getState) => {
    const state = getState()
    const formValues = getFormValues(FORM_EGRESO_CALADO)(state)
    const calleDeBruto = formValues.calleDeBruto
    dispatch({ type: 'START_EGRESO_CALLES_CALADO' })
    CalleCalado.egresoCpaCalado(numero, calleDeBruto)
      .then(() => {
        dispatch(updateViewPantallaConfirmacion(true))
        toast.success('Egreso realizado correctamente')
        dispatch(actualizarDatosEgresoQR())
      })
  }
}

export function getCeaParaEgreso (numero) {
  return (dispatch) => {
    return ConsultaCea.getById(numero)
      .then(cea => {
        dispatch({ type: 'RECEIVE_CEA_PARA_EGRESO' })
        console.log(cea)
        if (cea && (parseInt(cea.ctg) === parseInt(numero))) {
          if (!cea.fechaDeEgresoCalado) {
            if (cea.estadoCalificacion === 'R') {
              toast.error(`Carta de porte con rechazo en calado`, { autoClose: false })
              dispatch(updateConsultaCea(null))
            } else {
              if (cea.rechazoAdministrativoCalado === 'R') {
                toast.error(`Carta de porte con rechazo administrativo en calado`, { autoClose: false })
                dispatch(updateConsultaCea(null))
              } else if (cea.rechazoAdministrativoCalado === 'P') {
                toast.info(`Carta de porte pendiente de autorizar en calado`, { autoClose: false })
                dispatch(updateConsultaCea(null))
              } else if (cea.estadoCtg === 'A') {
                toast.info(`Carta de porte pendiente de actualizar desde ARCA`, { autoClose: false })
                dispatch(updateConsultaCea(null))
              } else {
                dispatch(updateConsultaCea(cea))
                dispatch(updateShowConfirmacionEgreso(true))
              }
            }
          } else {
            toast.warn(`Carta de porte con egreso de calado`, { autoClose: false })
            dispatch(updateConsultaCea(null))
          }
        } else {
          dispatch(updateConsultaCea(null))
        }
      })
  }
}
export function obtenerDatosCamionesCaladosPorCalle () {
  return (dispatch, getState) => {
    const camionesCaladosPorCalle = new CalleCalado()
    return camionesCaladosPorCalle.getCallesCaladoPorCalle()
      .then((data) => dispatch({
        type: 'CAMIONES_CALADOS_POR_CALLE',
        data
      }))
  }
}

export function resetCamionesCalados () {
  return (dispatch) => {
    dispatch({ type: 'RESET_CAMIONES_CALADOS' })
  }
}

export function consultaEstadoOcupacionCallesCalado () {
  return (dispatch) => {
    dispatch({ type: 'RESET_ESTADO_CALLES_CALADO' })
    return CalleCalado.getConsultaEstadoOcupacionCallesCalado()
      .then((data) => dispatch({
        type: 'ESTADO_CALLES_CALADO',
        data
      }))
  }
}

export function consultaCalificacionPorCalleCalado () {
  return (dispatch) => {
    return CalleCalado.getConsultaCalificacionPorCalleCalado()
      .then((data) => dispatch({
        type: 'CONSULTA_CALIFICACION_POR_CALLE_CALADO',
        data
      }))
  }
}

export function cargarPendientes (selections) {
  return dispatch => {
    dispatch({ type: 'CARGAR_PENDIENTES', pendientes: selections })
  }
}

export function actualizarEntregadoresPendientes (entregador, callback = null) {
  return (dispatch, getState) => {
    const state = getState()
    const { pendientesSeleccionados } = state.calado
    dispatch({ type: 'ACTUALIZAR_PENDIENTES' })
    CargaEntranteAutomotorCalado.actualizarEntregadorPendientesAutoriz(pendientesSeleccionados, entregador)
      .then(result => {
        const errorPendientesProcesados = result.reduce(
          (acc, curr) => {
            if (curr['error']) return curr['message']
            return acc
          }
          , null)
        const pendientesProcesados = result['length'] || 0
        dispatch({ type: 'PENDIENTES_FINALIZADOS',
          pendientesProcesados,
          errorPendientesProcesados })

        if (errorPendientesProcesados) {
          console.log('Error al intentar actualizar datos en carga entrante automotor : ', errorPendientesProcesados)
          toast.error('Error al intentar actualizar pendientes')
        }
        dispatch(getPendienteAutoriz())
        callback && callback(result)
      })
      .catch((error) => {
        console.log(error)
        toast.error('Error al intentar actualizar pendientes')
      })
  }
}

export function procesarPendientes (fn, tipo = null, finalizar = true, entregador = null, callback = null) {
  return (dispatch, getState) => {
    const state = getState()
    const { pendientesSeleccionados } = state.calado
    dispatch({ type: 'PROCESAR_PENDIENTES' })
    fn(pendientesSeleccionados)
      .then(result => {
        const errorPendientesProcesados = result.reduce(
          (acc, curr) => {
            if (curr['error']) return curr['message']
            return acc
          }
          , null)
        if (finalizar) {
          const pendientesProcesados = result['length'] || 0
          dispatch({ type: 'PENDIENTES_FINALIZADOS',
            pendientesProcesados,
            errorPendientesProcesados })
        }

        // si no hubo error en la transaccion anterior, se continua procesando
        if (!result.error && !errorPendientesProcesados) {
          if (tipo === 'REC') {
            let i = 0
            const promises = []
            const pendientesTransacciones = []
            pendientesSeleccionados.forEach((value) => {
              promises.push(CargaEntranteAutomotorCalado.rechazarPendientesEnAfip(value.cartaDePorteAutomotor, value.ctg, 'Rechazo Administrativo'))
            })
            Promise.all(promises).then(function (result) {
              console.log('result ', result)
              if (!result.error) {
                result.forEach(function (obj) {
                  console.log('Fin de la ejecucion', obj.data.filas[0].rechazarctg)
                  pendientesTransacciones.push(`CP: ${pendientesSeleccionados[i].cartaDePorteAutomotor} --> Trans.: ${obj.data.filas[0].rechazarctg}`)
                  i++
                })
              } else {
                toast.error('Error al intentar rechazar en ARCA')
                console.log(result)
              }
              dispatch({ type: 'END_RECHAZO_ARCA', pendientesTransacciones })
            })
          }
          if (entregador) {
            dispatch(actualizarEntregadoresPendientes(entregador))
          }
        } else {
          console.log(errorPendientesProcesados)
          toast.error('Error al procesar cargas pendientes.')
        }
        dispatch(getPendienteAutoriz())
        callback && callback(result)
      })
      .catch((error) => {
        console.log(error)
        toast.error('No se pudieron procesar correctamente las cargas pendientes.')
      })
  }
}

export function autorizarPendientes (finalizar = true, entregador = null) {
  return procesarPendientes(
    CargaEntranteAutomotorCalado.autorizarPendientesAutoriz, 'AUT', finalizar, entregador)
}

export function rechazarPendientes (finalizar = true, entregador = null) {
  return procesarPendientes(
    CargaEntranteAutomotorCalado.rechazarPendientesAutoriz, 'REC', finalizar, entregador)
}

// export function actualizarPendientes (entregador) {
//   return actualizarEntregadoresPendientes(
//     CargaEntranteAutomotorCalado.actualizarEntregadorPendientesAutoriz, entregador)
// }

export function hidePendientesProcesados () {
  return dispatch => dispatch({ type: 'OCLUTAR_PENDIENTES_STATUS' })
}

export function verificarEgreso (numero) {
  return (dispatch) => {
    dispatch(requestDatosConsultaCpa(numero, (cpa) => {
      if (cpa) {
        dispatch(requestCea(cpa.numero, (cea) => {
          if (cea && cea['fechaDeEgresoCalado']) {
            dispatch(anulacionEgresoNextStep())
          } else {
            toast.error('No se puede anular egreso de esta carta de porte.', { autoClose: false })
            dispatch(finalizarAnulacionEgreso())
          }
        }))
      } else {
        toast.error('No se ha encontrado la carta de porte.')
        dispatch(finalizarAnulacionEgreso())
      }
    }))
  }
}

export function openDialogPdf () {
  return (dispatch) => {
    const closeCallback = () => {
      dispatch({
        type: 'CLOSE_DIALOG'
      })
    }
    dispatch({
      type: 'OPEN_DIALOG',
      maxWidth: 'lg',
      content: <DialogPdfAfip closeCallback={closeCallback} />,
      closeCallback
    })
  }
}

export function anularEgresoCalado (onSuccess) {
  return (dispatch, getState) => {
    const state = getState()
    const anulacionEgreso = getFormValues(FORM_ANULACION_EGRESO)(state)
    console.log(anulacionEgreso)
    CalleCalado.anulacionEgresoCpaCalado(anulacionEgreso.numero)
      .then(deleteStatus => {
        dispatch({
          type: 'ANULACION_EGRESO_STATUS',
          anulacionEgresoDeleteResponse: deleteStatus
        })
        if (!deleteStatus.error) {
          dispatch(finalizarAnulacionEgreso())
          onSuccess()
          toast.success('Operación realizada exitosamente.')
        }
      })
  }
}

export function anulacionEgresoNextStep () {
  return (dispatch) => {
    return dispatch({ type: 'ANULACION_EGRESO_NEXT_STEP' })
  }
}

export function anulacionEgresoPrevStep () {
  return (dispatch) => {
    return dispatch({ type: 'ANULACION_EGRESO_PREV_STEP' })
  }
}

export function finalizarAnulacionEgreso () {
  return dispatch => {
    dispatch({ type: 'END_ANULACION_EGRESO' })
  }
}

export function updateCondicionIngreso (newState) {
  return (dispatch) => {
    dispatch({
      type: 'UPDATE_CONDICION_INGRESO',
      newState
    })
  }
}

export function updateShowCaladoConfirmacionAnulacion (show) {
  return (dispatch) => {
    dispatch({
      type: 'UPDATE_CALADO_MODAL_ANULACION_ANALISIS',
      show
    })
  }
}

export function updateShowConfirmacionEgreso (newValue) {
  return (dispatch) => {
    dispatch({
      type: 'UPDATE_SHOW_CONFIRMACION_EGRESO',
      newValue
    })
  }
}

export function updateViewPantallaConfirmacion (newValue) {
  return (dispatch) => {
    dispatch({
      type: 'UPDATE_VIEW_PANTALLA_CONFIRMACION',
      newValue
    })
  }
}

export function updateHumedad (newValue) {
  return (dispatch) => {
    dispatch({
      type: 'UPDATE_HUMEDAD',
      newValue
    })
  }
}

export function setPreingresoOn (newState) {
  return (dispatch) => {
    dispatch({
      type: 'SET_PREINGRESO_ON',
      newState
    })
  }
}

export function dialogHuella (tipo) {
  return async (dispatch) => {
    dispatch(openDialogHuella(tipo))
    const data = await obtenerHuellaDigital(tipo)
    console.log('Huella data', data)
    dispatch(closeDialogHuella())
    return data
  }
}

export function updateReloadState (newValue) {
  return (dispatch) => {
    dispatch({
      type: 'UPDATE_RELOAD_STATE',
      newValue
    })
  }
}

export function updateCerealCalleDeCalado (calle, cereal) {
  return () => {
    CalleCalado.updateCerealCalleDeCalado(calle, cereal)
  }
}

export function updateCalleDeCalado (numero, cereal, capacidad, habilitado) {
  return (dispatch) => {
    CalleCalado.updateCalleDeCalado(numero, cereal, capacidad, habilitado)
      .then((result) => {
        if (!result.error) {
          toast.success(`La calle ${numero} de calado se actualizo correctamente`)
          dispatch(obtenerDatosCallesDeCalado())
        }
      })
      .catch((error) => {
        console.log('Error: ', error)
        toast.error('Error al intentar actualizar la calle de calado')
      })
  }
}

export function getConsultaCpa (numero) {
  return (dispatch) => {
    dispatch(requestDatosConsultaCpa(numero))
  }
}

export function getDataCamionesCalados () {
  return (dispatch) => {
    return TablaCamionesCaladosService.getDataCamionesCalados()
      .then((data) => {
        dispatch({
          type: 'RECEIVE_DATA_CAMIONES_CALADOS',
          data
        })
      }

      )
  }
}

export function getDataCamionesEnPlaya () {
  return (dispatch) => {
    return dispatch(obtenerDatosCpaEnPlaya())
  }
}

export function obtenerProximoEgresoCalado () {
  return (dispatch) => {
    return CalleCalado.getProximoEgresoCalado()
      .then((data) => {
        dispatch({ type: 'RECEIVE_PROXIMO_EGRESO_CALADO', data })
      })
      .catch((error) => {
        console.log('Error: ', error)
      })
  }
}

export function abrirBarreraEntradaCalado () {
  return (dispatch) => {
    dispatch({ type: 'ABRIR_BARRERA_ENTRADA_CALADO' })
    BarreraCalado.abrirBarreraEntradaCalado()
    toast.info(`Abriendo barrera de entrada`)
  }
}

export function abrirBarreraSalidaCalado () {
  return (dispatch) => {
    dispatch({ type: 'ABRIR_BARRERA_SALIDA_CALADO' })
    BarreraCalado.abrirBarreraSalidaCalado()
    toast.info(`Abriendo barrera de salida`)
  }
}

export function cerrarBarreraEntradaCalado () {
  return (dispatch) => {
    dispatch({ type: 'CERRAR_BARRERA_ENTRADA_CALADO' })
    BarreraCalado.cerrarBarreraEntradaCalado()
    toast.info(`Cerrando barrera de entrada`)
  }
}

export function cerrarBarreraSalidaCalado () {
  return (dispatch) => {
    dispatch({ type: 'CERRAR_BARRERA_SALIDA_CALADO' })
    BarreraCalado.cerrarBarreraSalidaCalado()
    toast.info(`Cerrando barrera de salida`)
  }
}

export function abrirBarreraSalidaAlternativa () {
  return (dispatch) => {
    dispatch({ type: 'ABRIR_BARRERA_SALIDA_CALADO_ALTERNATIVA' })
    BarreraCalado.abrirBarreraSalidaCaladoAlternativa()
    toast.info(`Abriendo barrera alternativa de salida`)
  }
}

export function cerrarBarreraSalidaAlternativa () {
  return (dispatch) => {
    dispatch({ type: 'CERRAR_BARRERA_ENTRADA_CALADO_ALTERNATIVA' })
    BarreraCalado.cerrarBarreraSalidaCaladoAlternativa()
    toast.info(`Cerrando barrera alternativa de entrada`)
  }
}

export function estadoBarreraSalida () {
  return (dispatch) => {
    BarreraCalado.getEstadoBarreraSalida()
      .then((estado) => dispatch({
        type: 'ESTADO_BARRERA_SALIDA_ALTERNATIVA',
        estado
      }))
  }
}

export function parseData (data) {
  const parsedData = []
  data.filas.map((entry) => {
    return parsedData.push({ ...entry, cea: entry })
  })

  return parsedData
}

export function actualizarCamionesCalados () {
  return async dispatch => {
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        isLoading: true
      },
      id: TABLA_CAMIONES_CALADO_EN_CALLES
    })

    const d = await CamionesCalados.getCamionesCalados()
    return callback(d)
    async function callback (d) {
      const data = parseData(d)
      const customToolbar = null
      dispatch({
        type: 'UPDATE_MUITABLE',
        newState: {
          columns: COLUMNS_CAMIONES_CALADO_EN_PLAYA,
          data: data,
          title: 'Camiones calados en playa',
          isLoading: false,
          fixed2Decimales: false,
          extraOptions: { customToolbar, print: false, pagination: false, tableBodyMaxHeight: '450px' }
        },
        id: TABLA_CAMIONES_CALADO_EN_CALLES
      })
    }
  }
}

export function updateCalleCamionCalado (numero, fecha, calle) {
  return (dispatch) => {
    CargaEntranteAutomotorCalado.updateCalleDeCalado(numero, fecha, calle)
      .then(() => {
        toast.success('Se modifico correctamente la calle')
        dispatch(actualizarCamionesCalados())
      })
  }
}

export function openEdicionCalleCamionCaladoDialog () {
  return (dispatch, getState) => {
    const cancelCallback = () => {
      dispatch({
        type: 'CLOSE_DIALOG',
        id: 'EDICION_CALLE_CAMION_CALADO'
      })
      Promise.all([
        dispatch(consultaEstadoOcupacionCallesCalado()),
        dispatch(consultaCalificacionPorCalleCalado()),
        dispatch(actualizarCamionesCalados())
      ])
        .then(() => {
          dispatch({ type: 'END_EDICION_CALLE_CAMION_CALADO' })
        })
    }
    dispatch({
      type: 'OPEN_DIALOG',
      id: 'EDICION_CALLE_CAMION_CALADO',
      maxWidth: 'xl',
      content: <DialogoCalleCamionCaladoUpdate
        cancelCallback={cancelCallback}
      />
    })
    dispatch({
      type: 'EDICION_CALLE_CAMION_CALADO'
    })
  }
}

export function getCallesDeCaladoPorCerealHumedad () {
  return dispatch => {
    dispatch({ type: 'REQUEST_CALLES_DE_CALADO_POR_CEREAL_HUMEDAD' })
    return CalleCalado.getCallesCaladoPorCerealHumedad()
      .then((data) => {
        dispatch({ type: 'CALLES_DE_CALADO_POR_CEREAL_HUMEDAD', data })
      })
  }
}

export function obtenerCamionesEntrePlayaCalado () {
  return dispatch => {
    dispatch(getCamionesEntrePlayaCalado())
  }
}

export function getCamionesListosParaBruto () {
  return dispatch => {
    dispatch(camionesListosParaBruto())
  }
}

export function obtenerEstadoPedidosCereal () {
  return dispatch => {
    dispatch(getCortesPedidos())
  }
}

export function saveDetallePdf () {
  return (dispatch, getState) => {
    dispatch({
      type: 'GENERAR_DETALLE_PDF',
      fileDetallePdfOk: false
    })
    dispatch({
      type: 'DETALLE_MERCADERIA',
      data: []
    })
  }
}

export function parseDataCalle (data) {
  const parsedData = []
  data && data.map((d) => {
    return parsedData.push({ ...d, entry: d })
  })
  return parsedData
}

export function obtenerDatosCallesDeCalado () {
  return (dispatch) => {
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        isLoading: true
      },
      id: TABLA_CALLES_DE_CALADO
    })
    CalleCalado.getCallesCaladoPorCalle().then(callback)
    async function callback (d) {
      const data = parseDataCalle(d)
      const customToolbar = null

      dispatch({
        type: 'UPDATE_MUITABLE',
        newState: {
          columns: COLUMNS_CALLE_CALADO,
          data: data,
          title: 'Calles de calado',
          isLoading: false,
          fixed2Decimales: false,
          extraOptions: { customToolbar, print: false, pagination: false, monthFilter: true }
        },
        id: TABLA_CALLES_DE_CALADO
      })
    }
  }
}
